module.exports = __webpack_public_path__ + "static/media/1pic.5c7a7eb8.png";